import { Modal } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  ${Modal.Styled.ModalContainer} {
    height: calc(100% - 24px);
    max-height: 724px;
    width: 914px;
    padding-bottom: 0px;
  }
`;
